import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./index.less";
import { Button, Card, Col, List, Row, Space, Tooltip } from "antd";
import {
  ArrowRightOutlined,
  DeleteOutlined,
  EditOutlined,
  LeftOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { loadAddresses } from "../../../../../application/addresses";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../application/store";
import I18n from "../../../../i18n";
import DeleteAddressModal from "./components/DeleteAddressModal";
import NewAddressModal from "./components/NewAddressModal";
import EditAddressModal from "./components/EditAddressModal";
import { Address } from "../../../../../domain";
import { DocumentTitle } from "../../../../components";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";

export default function Addresses() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { addresses, loadingAddresses } = useAppSelector(
    (state) => state.addresses
  );

  const [deleteModalState, setDeleteModalState] = useState<{
    visible: boolean;
    addressId?: number;
  }>({ visible: false });
  const openDeleteModal = (addressId: number) =>
    setDeleteModalState({ visible: true, addressId });
  const closeDeleteModal = () =>
    setDeleteModalState({ visible: false, addressId: undefined });

  const [editModalState, setEditModalState] = useState<{
    visible: boolean;
    address?: Address;
  }>({ visible: false });
  const openEditModal = (address: Address) =>
    setEditModalState({ visible: true, address });
  const closeEditModal = () =>
    setEditModalState({ visible: false, address: undefined });

  const [newAddressModalState, setNewAddressEditModalState] = useState<{
    visible: boolean;
  }>({ visible: false });
  const openNewAddressModal = () =>
    setNewAddressEditModalState({ visible: true });
  const closeNewAddressModal = () =>
    setNewAddressEditModalState({ visible: false });

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadAddresses());
  }, [stableDispatch]);

  const isLoading = loadingAddresses === "pending";
  return (
    <DocumentTitle title={I18n.profile.tabs.addresses}>
      <Card bodyStyle={{ padding: 0 }}>
        <Row
          className={`addresses-title${
            isMobile ? " addresses-title-mobile" : ""
          }`}
          align="middle"
        >
          {isMobile ? (
            <Button
              style={{ marginLeft: 8 }}
              type="text"
              size="small"
              onClick={() => history.goBack()}
            >
              <ArrowRightOutlined />
            </Button>
          ) : (
            <Fragment />
          )}
          <div>{I18n.profile.tabs.addresses}</div>
        </Row>
        <List
          loading={isLoading}
          dataSource={addresses}
          renderItem={(item, index) => {
            return (
              <List.Item
                key={index}
                actions={[
                  <Tooltip title={I18n.profile.edit}>
                    <Button
                      type="link"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => openEditModal(item)}
                    />
                  </Tooltip>,
                  <Tooltip title={I18n.general.delete}>
                    <Button
                      type="link"
                      size="small"
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => openDeleteModal(item.id)}
                    />
                  </Tooltip>,
                ]}
              >
                <Col style={{ paddingLeft: 16, paddingRight: 16 }}>
                  <div className="addrees-item-title">{item.address}</div>
                  <div className="addrees-item-detail">{`${item.state}، ${item.city}`}</div>
                  <div className="addrees-item-detail">{item.zipCode}</div>
                </Col>
              </List.Item>
            );
          }}
          footer={
            <Button type="link" block onClick={openNewAddressModal}>
              <Row justify="space-between" align="middle">
                <Row align="middle">
                  <Space>
                    <PlusOutlined />
                    <div className="add-new-address-button">
                      {I18n.profile.addNewAddress}
                    </div>
                  </Space>
                </Row>
                <LeftOutlined />
              </Row>
            </Button>
          }
        />

        {/* delete modal */}
        <DeleteAddressModal
          visible={deleteModalState.visible}
          onClose={closeDeleteModal}
          addressId={
            deleteModalState.addressId === undefined
              ? 0
              : deleteModalState.addressId
          }
        />

        {/* new address modal */}
        <NewAddressModal
          visible={newAddressModalState.visible}
          onClose={closeNewAddressModal}
        />

        {/* edit modal */}
        <EditAddressModal
          visible={editModalState.visible}
          onClose={closeEditModal}
          currentAddress={editModalState.address}
        />
      </Card>
    </DocumentTitle>
  );
}
